module.exports = __webpack_public_path__ + "img/icon-to-next.833b4ddf.svg";